import { TabComponentTypes } from 'components/types/company';
import React from 'react';

interface PropTypes {
  tab: number,
  dataTab: {
    id: number,
    name: string,
  }[],
  handleClickTab: (val: TabComponentTypes) => void,
  className? : string,
}

const index = ({
  tab, dataTab, handleClickTab, className,
}: PropTypes) => {
  const lengthDatas = dataTab?.length;
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      {dataTab?.map((value) => (
        <React.Fragment key={value.id}>
          <span
            tabIndex={0}
            className={`btn activeText ${tab === value.id && 'active'} !tw-shadow-none`}
            role="button"
            onClick={() => handleClickTab(value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClickTab(value);
              }
            }}
          >
            {value.name}
          </span>
          {value.id !== lengthDatas ? (
            <span className="mr-3 ml-3 rOrgLinkSeparator">|</span>
          ) : (
            null
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default index;
